module.exports = __webpack_public_path__ + "static_pc/img/pxs.f0aa8643.png";